export const formatCurrency = (value: string) => {
  const floatValue = parseFloat(value)
  return `£${floatValue.toFixed(2)}`
}